import axios from "axios";

const blockedUserData = (
  formState,
  setVendorData,
  setInvoiceLoading,
  setCount
) => {
  // setInvoiceLoading(true);

  const statusValue = formState.State === "Blocked" ? false : true;

  const params = {
    pageNumber: formState.PageNo || 1,          // use PageNo from formState or fallback to 1
    pageSize: formState.RowsOfPage ||25,
        isAsc:formState.isAsc,
    status: statusValue,
  };

if (formState?.Vendor && formState?.Vendor?.Vendor_Code && formState?.Vendor?.Vendor_Code !== "-1") {
  let rawCode = formState?.Vendor?.Vendor_Code;
  if (rawCode?.startsWith("000")) {
    rawCode = rawCode?.slice(3);
  }
  params.VendorCode = rawCode;
}

  return axios({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/api/Vendor/GetVendorsFromI2p`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: params,
  })
    .then((res) => {
      setVendorData(res?.data?.response || []);
      setCount(parseInt(res?.data?.totalCount) || 0);
      // setInvoiceLoading(false);
    })
    .catch((err) => {
      console.error("Error fetching blocked/unblocked vendors:", err);
      // setInvoiceLoading(false);
    });
};


const changeVendorAccess = async (vendorList , state , setOpenModel , setSelectedVendors , setWaitMessage )=> {
  // const vendors = [1003142 , 1006016]
  const formattedPayload = {
    vendor_Code:vendorList?.map((item)=>item),
    status:state === "Unblocked" ? false : true
  }
  try {
    const response = await axios({
      method : "put" , 
      url: `${process.env.REACT_APP_API_URL}/api/Vendor/UpdateVendorStatus`, 
      headers :{
        Authorization : `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
      },
      data : formattedPayload
    

    }).then(async(res) => {
      setOpenModel(false)
      setSelectedVendors ([])
      setWaitMessage("")
     
    })


  }
  catch (error){
    
    
  }

}

export { blockedUserData , changeVendorAccess };
